import React from 'react';

export const AuthContext = React.createContext({
  user: null,
  setUser: () => {},
  sessionProject: null,
  setSessionProject: () => {},
  handleLogout: () => {},
});